import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Button,  Col, Row, FormFeedback } from 'reactstrap';
import { TextInput, SlButton, SlFormEntryRow } from '../editors';
import { metadataService } from "../../_services"

import validator from 'validator'; 

export class ChangePassword extends Component {
    static displayName = ChangePassword.name;

    constructor(props) {
        super(props);
        
        this.state =  {
            CurrentPassword: '', 
            NewPassword: '', 
            ConfirmPassword: '', 
            fieldErrors: [], 
            formError:'', 
            isValid:false 
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.valueChanged = this.valueChanged.bind(this);
    }

    handleSubmit(){
        //validation. 
        if(this.handleValidation(this.state, true)){
            //OK to submit. 
            this.props.executeChangePassword(this.state.CurrentPassword, this.state.NewPassword);
        }
    }

    handleValidation(values, setErrors){
        
        let fieldErrors = [];
        
        if(validator.isEmpty(values.CurrentPassword)){
            fieldErrors.push({fieldName:"CurrentPassword", messageName:"RequiredFieldNotSupplied"})
        }
        
        if(validator.isEmpty(values.NewPassword)){
            fieldErrors.push({fieldName:"NewPassword", messageName:"RequiredFieldNotSupplied"})
        }
        //else if (zxcvbn(values.NewPassword) <= 2){
        //    fieldErrors.push({fieldName:"NewPassword", messageName:"PasswordRequirements"})
        //}
        if(validator.isEmpty(values.ConfirmPassword)){
            fieldErrors.push({fieldName:"ConfirmPassword", messageName:"RequiredFieldNotSupplied"})
        }

        if (!metadataService.checkPasswordComplexity(values.NewPassword)) {
            fieldErrors.push({fieldName:"NewPassword", messageName:"PasswordRequirements"})
        }

        else if (values.NewPassword !== values.ConfirmPassword){
            fieldErrors.push({fieldName: "ConfirmPassword", messageName:"PasswordsDoNotMatch"})
        }
        if(setErrors){
            this.setState({fieldErrors : fieldErrors})        
        }
        return fieldErrors.length === 0; 
    }

    valueChanged(e){
        const targetName = e.target.name;
        let newState = {};
        newState[targetName] = e.target.value;
        const changedState = {...this.state, ...newState}
        newState.isValid = this.handleValidation(changedState, false);
        this.setState(newState);
    }

    render() {
        return (
            <div className="ChangePassword">
                <Card>
                    <CardBody>
                        <SlFormEntryRow>
                                <TextInput name='CurrentPassword' type='password' value={this.state.CurrentPassword} onChange={this.valueChanged} fieldErrors={this.state.fieldErrors}/>
                        </SlFormEntryRow>
                        <SlFormEntryRow>
                                <TextInput name='NewPassword' type='password' value={this.state.NewPassword} onChange={this.valueChanged} fieldErrors={this.state.fieldErrors}/>
                        </SlFormEntryRow>
                        <SlFormEntryRow>
                                <TextInput name='ConfirmPassword' type='password' value={this.state.ConfirmPassword} onChange={this.valueChanged} fieldErrors={this.state.fieldErrors}/>
                        </SlFormEntryRow>
                        <SlFormEntryRow>
                            {this.props.formError && (<FormFeedback invalid style={{display:'block', textAlign:'center'}}>{this.props.formError}</FormFeedback>)}
                        </SlFormEntryRow>
                    </CardBody>
                </Card>
                <SlFormEntryRow>
                    <p className="passwordHelpText">{metadataService.getMessage('PasswordRequirements')}</p>
                </SlFormEntryRow>
                <SlFormEntryRow>
                        <div className="text-center">
                            <SlButton name="Submit" onClick={this.handleSubmit} disabled={!this.state.isValid}/>
                        </div>
                </SlFormEntryRow>
            </div>
        );
    }
}

ChangePassword.propTypes = {
    executeChangePassword : PropTypes.func.required, 
    valueChanged : PropTypes.func.required, 
    values : PropTypes.array.required,
    errors : PropTypes.array, 
    formError : PropTypes.string 
}


// WEBPACK FOOTER //
// ./src/components/subcomponents/ChangePassword.js